import { useEffect, useState } from "react";
import { cx } from "@wato/ui";

/**
 * Round photo with an initials fallback (AVA-01/02). Lazy-loaded, no referrer, and any load error
 * (hidden / removed photo) falls back to the initials. `alt` defaults to "" (decorative) because
 * the person's name is always rendered next to it.
 */
export function Avatar({
  src,
  initials,
  alt = "",
  className,
}: {
  readonly src?: string | null | undefined;
  readonly initials: string;
  readonly alt?: string;
  readonly className?: string;
}) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  return (
    <span
      aria-hidden={alt === "" ? "true" : undefined}
      className={cx(
        "inline-flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-full text-xs font-semibold",
        className?.includes("bg-") ? "" : "bg-neutral-700 text-neutral-0",
        className,
      )}
    >
      {src && !failed ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          referrerPolicy="no-referrer"
          onError={() => setFailed(true)}
          className="size-full object-cover"
        />
      ) : (
        initials
      )}
    </span>
  );
}
